import React, { useContext }  from 'react'
import UnderlaymentProduct from './UnderlaymentProduct'
import { AppContext } from '../../../App'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'

export default function UnderlaymentProductList() {
   const { underlaymentProducts } = useContext(AppContext)
   const allUnderlaymentSubCategories = underlaymentProducts.map(u => u.subCategory)
   const underlaymentSubCategories = [...new Set(allUnderlaymentSubCategories)].sort()
    const iconAngleDown = <FontAwesomeIcon icon={faAngleDown} color="#ffffff" />

   return (
      <div className="underlayment-product-list">
         <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
         {
            underlaymentSubCategories.map((usc, index) => {
                return (
                <div className="panel panel-primary" key={usc}>
               
                     <div className="panel-heading" role="tab" id={ "heading-" + usc }>
                        <a role="button" data-bs-toggle="collapse" data-parent="#accordion" href={ "#collapse-" + index } aria-expanded="true" aria-controls={ "collapse-" + index }>
                           <h4 className="panel-title">{ iconAngleDown } { usc }</h4>
                        </a>
                     </div>
                     <div id={ "collapse-" + index } className={ index===0 ? "panel-collapse collapse in" : "panel-collapse collapse" } role="tabpanel" aria-labelledby={ "heading-" + usc }>
                        <div className="panel-body">
                           {
                              underlaymentProducts.map((u, index) => {
                                 return u.subCategory===usc && (
                                    <UnderlaymentProduct key={ u.name } productIndex={ index } { ...u } />
                                 )
                              })
                           }
                        </div>
                     </div>
                    </div>
                    )
               
            })
         }
         {
            underlaymentProducts.some(u => !u.subCategory) && (
               <div className="panel panel-primary list-items" key={ "no-subcategory" }>
                  <div className="panel-heading" role="tab" id={ "heading-no-subcategory" }>
                     <h4 className="panel-title">
                        <a role="button" data-bs-toggle="collapse" data-parent="#accordion" href={ "#collapse-no-subcategory" } aria-expanded="true" aria-controls={ "collapse-no-subcategory" }>
                           Uncategorized Underlayments
                        </a>
                     </h4>
                  </div>
                  <div id={ "collapse-no-subcategory" } className="panel-collapse collapse" role="tabpanel" aria-labelledby={ "heading-no-subcategory" }>
                     <div className="panel-body">
                     {
                        underlaymentProducts.map((u, index) => {
                           return !u.subCategory && (
                              <UnderlaymentProduct key={ u.name } productIndex={ index } { ...u } />
                           )
                        })
                     }
                     </div>
                  </div>
               </div>
            )
         }
         </div>
      </div>




      // <div className="panel panel-primary">
      //    <div className="panel-heading">
      //       <h4 className="panel-title">Select Underlayment</h4>
      //    </div>
      //    <div className="panel-body">
      //    {
      //    underlaymentProducts.map(u => {
      //       return (
      //          <UnderlaymentProduct key={u.productName} {...u} />
      //       )
      //    })}
      //    </div>
      // </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/underlayment/UnderlaymentProductList.js